import {getDomain} from "./cookie";
export default function handleRedirect (history, queryParamString, targetPath?: string) {

    const domain = getDomain('', process.env.REACT_APP_STAGE, window.location.hostname);
    const expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime()+(5*60*1000));
    document.cookie = `login-ts=${String(Date.now())};expires=${expirationDate.toUTCString()};path=/;domain=${domain}`;
    // keep original query params
    let params = new URLSearchParams(queryParamString);
    let redirectPath = "/citySelector";

    if (params.has("ssoids")){
        params.delete("ssoids");
    }
    // if we move to redirect to uri from query string, pop from query
    if (targetPath && validateUrl(targetPath)){
       redirectPath = targetPath
    } else {
       if (params.has("redirect_uri") && validateUrl(params.get("redirect_uri"))) {
           redirectPath = params.get("redirect_uri");
           params.delete("redirect_uri");
           const path = new URL(redirectPath);
           path.search = params.toString();
           window.location.assign(path.toString())
       }
    }

    try {
        const state = params.get("state");
        if(state){
            history.push({ pathname: redirectPath, search: atob(params.get("state")) });
        }
    } catch (e) {}
    history.push({ pathname: redirectPath});
};

export function getRedirectUri (history, queryParamString) {

    // keep original query params
    let params = new URLSearchParams(queryParamString);
    let redirectPath = "/citySelector";

    if (params.has("redirect_uri") && validateUrl(params.get("redirect_uri"))) {
        redirectPath = params.get("redirect_uri");
        return redirectPath;
    }
    return ""
};

function validateUrl(redirectURL) {
    let url = new URL(redirectURL);
    return !!getDomain('', process.env.REACT_APP_STAGE, url.origin);
};
